import { rootStateBranchSelector } from 'shared/utils/rootStateBranchSelector';

export const coworkingSelector = rootStateBranchSelector('coworking');
